module.exports = __webpack_public_path__ + "img/2.2c03b44d.svg";